import React from 'react';
import { motion } from 'framer-motion';
import './LandingTestimonials.css';
import LandingCard from '../LandingCard/LandingCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const testimonials = [
  {
    name: 'Sofía Herrera',
    role: 'Distribuidora ModaStyle',
    content: 'Vendo ropa al por mayor y antes perdía muchas ventas porque los clientes pedían prendas que ya no tenía. Ahora con OviCatalogos, cuando se me agota una talla o modelo, lo inhabilito y desaparece. ¡Mis clientes solo ven lo disponible!',
    initials: 'SH'
  },
  {
    name: 'Miguel Torres',
    role: 'Calzados El Paso',
    content: 'Manejo un catálogo grande de zapatos y tenis. Antes era un caos actualizar precios y disponibilidad. Con OviCatalogos actualizo todo desde un solo lugar y mis clientes reciben los pedidos por WhatsApp completos. Me ahorra horas cada día.',
    initials: 'MT'
  },
  {
    name: 'Valentina Cruz',
    role: 'Accesorios Luna Bella',
    content: 'Perfecto para mi negocio de accesorios. Puedo mostrar todas mis colecciones y cuando algo se agota, desaparece automáticamente. Mis clientas hacen sus pedidos directo a WhatsApp. Simple y efectivo.',
    initials: 'VC'
  }
];

function LandingTestimonials() {
  return (
    <section className="ovicatalogos-testimonials">
      <div className="ovicatalogos-testimonials-gradient" />
      
      <div className="ovicatalogos-testimonials-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="ovicatalogos-testimonials-header"
        >
          <h2 className="ovicatalogos-testimonials-title">
            Negocios reales que ya usan OviCatalogos
          </h2>
          <p className="ovicatalogos-testimonials-subtitle">
            Desde ropa, calzado hasta accesorios. Emprendedores y empresas confían en nuestros catálogos inteligentes
          </p>
        </motion.div>

        <div className="ovicatalogos-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <LandingCard className="ovicatalogos-testimonials-card">
                <LandingCard.Content>
                  <div className="ovicatalogos-testimonials-stars">
                    {[...Array(5)].map((_, i) => (
                      <FontAwesomeIcon 
                        key={i}
                        icon={faStar} 
                        className="ovicatalogos-testimonials-star"
                      />
                    ))}
                  </div>
                  
                  <p className="ovicatalogos-testimonials-content">
                    "{testimonial.content}"
                  </p>
                  
                  <div className="ovicatalogos-testimonials-author">
                    <div className="ovicatalogos-testimonials-avatar">
                      <span className="ovicatalogos-testimonials-initials">
                        {testimonial.initials}
                      </span>
                    </div>
                    <div className="ovicatalogos-testimonials-info">
                      <div className="ovicatalogos-testimonials-name">
                        {testimonial.name}
                      </div>
                      <div className="ovicatalogos-testimonials-role">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                </LandingCard.Content>
              </LandingCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LandingTestimonials;
